export const ROLE_LABEL = {
  admin: "Admin",
  gestore: "Gestore",
  operator: "Operatore",
  viewer: "Assistente Tecnico",
};

export function roleLabel(role) {
  return ROLE_LABEL[role] || role;
}
